import React, { useEffect } from "react";
import "./Toaster.css";
import { reactIcons } from "../../icons/reactIcons";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store";
import { setSnackbarDetails } from "../../redux/AuthReducer/AuthSlice";

interface ToasterProps {
  //   message: string;
  //   onClose: () => void;
  //   duration?: number; // default auto close time
}

const Toaster: React.FC<ToasterProps> = () => {
  const dispatch = useDispatch();
  const snackbarDetails = useSelector(
    (state: RootState) => state.Auth.snackbarDetails,
  );
  const snackbarList = snackbarDetails?.list ?? [];

  useEffect(() => {
    if (snackbarDetails.type && snackbarDetails.message) {
      const timer = setTimeout(() => {
        dispatch(setSnackbarDetails({ status: "", message: "" }));
      }, 5000);

      return () => clearTimeout(timer); // cleanup
    }
  }, [snackbarDetails.type, snackbarDetails.message, dispatch]);

  const handleClose = () => {
    dispatch(setSnackbarDetails({ status: "", message: "" }));
  };

  return (
    <div className="toaster">
      {snackbarDetails.type !== "" && snackbarDetails.message !== "" && (
        <div
          className={`toaster-container ${
            snackbarDetails.type === "success"
              ? "success"
              : snackbarDetails.type === "warning"
                ? "warning"
                : "fail"
          }`}
        >
          <div className="toaster-msgMain">
            <div className="toaster-icon">
              <reactIcons.checkMarkIcon />
            </div>
            <div className="toaster-message-wrapper">
              <span className="toaster-message">
                {snackbarDetails?.message}
              </span>
              {snackbarList.length > 0 && (
                <ul className="toaster-message-list">
                  {snackbarList.map((item, index) => (
                    <li key={`${item}-${index}`}>{item}</li>
                  ))}
                </ul>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Toaster;
